import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-modal">
      <span class="loader">MotoTaksi.az</span>
    </div>
  );
};

export default Loader;
